module.exports = __webpack_public_path__ + "img/504.49bbb9e5.png";